<template>
  <div class="input-range__container">
    <input
      type="range"
      :min="min"
      :max="max"
      :value="value"
      @change="onChange"
    />
    <input
      type="number"
      :min="min"
      :max="max"
      :value="value"
      @keyup="onChange"
      @change="onChange"
    />
  </div>
</template>

<script>
export default {
  name: "InputRange",
  props: ["value", "min", "max"],
  methods: {
    onChange({ target: { value } }) {
      this.$emit("input", value);
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="sass" scoped>
.input-range__container
  display: flex
  input[type="number"]
    margin: 0
    height: 37px
    min-width: unset
    width: 67px
    padding-right: 20px
    outline: none
    font-size: 14px
    background: #FAFBFC
    border: 1px solid #E2E4E9
    border-radius: 3px
    text-align: right
  input[type="range"]
    appearance: none
    flex: 1
    margin-right: 20px
    outline: none !important
    &::-webkit-slider-thumb
      appearance: none
      background: #0080FC
      width: 18px
      height: 18px
      margin-top: -5px
      transition: background 200ms
      border-radius: 18px
      &:hover
        background: darken(#0080FC, 5%)
    &::-webkit-slider-runnable-track
      appearance: none
      background: #EBEFF3
      border-radius: 0
      height: 8px
</style>


// WEBPACK FOOTER //
// src/components/editor/resource_components/Abstract/InputRange.vue